import { inject, provideAppInitializer } from '@angular/core';
import { SharedUiColorsCssVariablesAutoUpdateService } from './colors/shared-ui-colors-css-variable-auto-update.service';
import { SharedUiGapsCssVariablesAutoUpdateService } from './gaps/shared-ui-gaps-css-variable-auto-update.service';

export function provideThemingUi() {
    return provideAppInitializer(() => {
        const colorsAutoUpdateService = inject(SharedUiColorsCssVariablesAutoUpdateService);
        const gapsAutoUpdateService = inject(SharedUiGapsCssVariablesAutoUpdateService);
        colorsAutoUpdateService.enableColorCssVariablesAutoUpdate();
        gapsAutoUpdateService.defineGapsCssVariablesAutoUpdate();
    });
}
